import React, { useEffect, useMemo, useState } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { animated, useSpring } from 'react-spring'
import { useDispatch, useSelector } from 'react-redux'
import { IQuota, QuotaState } from 'interfaces/quota'
import { AppState } from 'interfaces/app'
import { setQuotas } from 'context/reducer/quota'
import { RootState } from 'context'
import { Quota } from './quota'
import { Amount } from './amountDestination'
import simulatorImage from 'assets/images/login/SimulatorImage-min.jpg'

interface DrawSimulatorProps {
  quotas: IQuota[]
  amount: string
}

const DrawSimulator: React.FC<DrawSimulatorProps> = ({ quotas, amount }) => {

  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const toggle = quotas.length > 0 && (amount === '' || amount !== 'NaN')

  const QuotaMemo = useMemo(() => <Quota></Quota>, [])

  const props = useSpring({
    config: { duration: 1000 },
    opacity: toggle ? 1 : 0,
    y: toggle ? 0 : -300,
    onRest: {
      opacity: () => {
        if (!toggle) {
          setOpen(false)
          dispatch(setQuotas([]))
        }
      }
    }
  })

  useEffect(() => {
    if (toggle) {
      setOpen(true)
    }
  }, [toggle])

  return (
    <Grid container justifyContent="center">
      <Grid item md={9} className='simulator-width'>
        <Grid container direction="column" justifyContent="center">
          <Grid item>
            <Amount />
          </Grid>
          {open && (
            <Grid item>
              <animated.div style={props} >
                {QuotaMemo}
              </animated.div>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}


const Simulator: React.FC = () => {
  const { quotas, amount } = useSelector<RootState, QuotaState>((state) => state.quota)
  const { isMobile } = useSelector<RootState, AppState>((state) => state.app)
  return (
    <div className="bp-mt-16 bp-mb-32" id='simulador'>
      <img src={simulatorImage} width="100%" alt="" />
      {isMobile
        ?
        <DrawSimulator quotas={quotas} amount={amount}></DrawSimulator>
        : <Container maxWidth="xl">
          <DrawSimulator quotas={quotas} amount={amount} />
        </Container>}
    </div>
  )
}

export default Simulator
